module.exports = __webpack_public_path__ + "static/media/teacherbots-createnew-screenshot.e7789b57.png";